import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedAdminRoute = () => {
  const { currentAdmin, loading } = useAdminAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return currentAdmin ? <Outlet /> : <Navigate to="/admin/login" />;
};

export default ProtectedAdminRoute;